import { render, staticRenderFns } from "./CommonContentWrapper.vue?vue&type=template&id=fd99d5e0"
import script from "./CommonContentWrapper.vue?vue&type=script&lang=js"
export * from "./CommonContentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports